module.exports = __webpack_public_path__ + "img/advantage_2.4a94dd09.png";